var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2167",
    d: "M13.0737 2.88545C13.8189 2.07808 14.1915 1.6744 14.5874 1.43893C15.5427 0.870759 16.7191 0.853091 17.6904 1.39232C18.0929 1.6158 18.4769 2.00812 19.245 2.79276C20.0131 3.5774 20.3972 3.96972 20.6159 4.38093C21.1438 5.37312 21.1265 6.57479 20.5703 7.5507C20.3398 7.95516 19.9446 8.33578 19.1543 9.09701L9.75063 18.1543C8.25288 19.5969 7.504 20.3182 6.56806 20.6837C5.63212 21.0493 4.6032 21.0224 2.54536 20.9686L2.26538 20.9613C1.63891 20.9449 1.32567 20.9367 1.14359 20.73C0.961503 20.5234 0.986362 20.2043 1.03608 19.5662L1.06308 19.2197C1.20301 17.4235 1.27297 16.5255 1.62371 15.7182C1.97444 14.9109 2.57944 14.2555 3.78943 12.9445L13.0737 2.88545Z",
    stroke: "#47525D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4200",
    d: "M12 3L19 10",
    stroke: "#47525D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4201",
    d: "M13 21L21 21",
    stroke: "#47525D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGray);
export default __webpack_public_path__ + "static/media/edit-gray.1a401381b47f42508edc14a84e6fd67a.svg";
export { ForwardRef as ReactComponent };